import { Ticket } from "../models/ticket.model";
import { ToolRequest } from "../models/toolRequests.model";
import { ToolReturn } from "../models/tool-return.model";
import { ToolTransport } from "../models/tool-transport.model";


export class TableConfig {
    sorter = {
        field: '',
        IsSortingAscending: false
    };
    pager = {
        count: 0,
        groupToolCount: 0,
        selected: 0,
        page: 1,
        pageSize: 20
    };
    filters: Array<any> = [];
    groupers: Array<any> = [];

    upsertFilter(name: string, value: any) {
        if (!value) {
            return;
        }
        const filter = this.filters.find(x => x.field === name);
        if (!filter) {
            this.filters.push(
                {
                    field: name,
                    value: value
                }
            );
            return;
        }
        if (!value && filter) {
            this.filters.splice(this.filters.indexOf(filter), 1);
            return;
        }
        filter.value = value;
    }

    removeFilter(name: string) {
        const filter = this.filters.find(x => x.field === name);

        if (!filter) {
            return;
        }
        this.filters.splice(this.filters.indexOf(filter), 1);
    }

    sameValue(name: string, value: string): boolean {
        const filter = this.filters.find(x => x.field === name);
        return filter && filter.value === value;
    }

    setMultipleFilters(field: string, values: number[]) {
        for (const value of values) {
            this.filters.push({field, value});
        }
    }

    removeMultipleFilters(filterToRemove: string) {
        this.filters = this.filters.filter(filter => filter.field !== filterToRemove);
    }

}

export class TableConfigUtils {

    private static recordColor = '#d4f8d4'

    public static addColorToToolRequestsByPriority(toolRequests: ToolRequest[]): ToolRequest[] {
        return toolRequests.map((record: any) => {
            if (record.highPriority) {
                record.color = this.recordColor;
            }
            return record;
        });
    }

    public static addColorToTicketByPriority(tickets: Ticket[]): Ticket[] {
        return tickets.map((record: any) => {
            if (record.hasPriority) {
                record.color = this.recordColor;
            }
            return record;
        })
    }

    public static addColorToToolReturnsByPriority(toolReturns: ToolReturn[]): ToolReturn[] {
        return toolReturns.map((record: any) => {
            if (record.hasPriority) {
                record.color = this.recordColor;
            }
            return record;
        });
    }

    public static addColorToToolTransportByPriority(toolTransport: ToolTransport[]): ToolTransport[] {
        return toolTransport.map((record: any) => {
            if (record.hasPriority) {
                record.color = this.recordColor;
            }
            return record;
        });
    }
}
